import { render, staticRenderFns } from "./EditBeneficiary.vue?vue&type=template&id=28c6b8fb&"
import script from "./EditBeneficiary.vue?vue&type=script&lang=js&"
export * from "./EditBeneficiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports